
<nav class="navbar navbar-light justify-content-center" style="background-color: #f2f3fb;">
 <div class="container">
   <div class="row">
     <div class="col-md-1 d-flex align-items-center">
       <a class="d-none d-lg-block" href="#"><img  src="assets/images/left_arrow.png"/></a>
     </div>
     <div class="col-md-10">
      <app-promos></app-promos>
     </div>
     <div class="col-md-1 d-flex align-items-center">
      <a class="d-none d-lg-block" href="#"><img src="assets/images/right_arrow.png"/></a>
     </div>
   </div>
 </div>
</nav>

<nav class="navbar navbar-light justify-content-center" style="background-color: #f2f3fb;">
  <a href="#"><img class="" src="assets/images/pagination.png"/></a>
</nav>

